// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2otBd","delete":"styles_delete__vPMyh","update":"styles_update__SXaLN","add":"styles_add__34WbI"};